<mat-checkbox
  color="primary"
  (change)="sourceSelected.emit($event.checked)"
  [checked]="initialChecked"
  [disabled]="disabled"
>
  <img
    class="source-icon"
    [src]="
      'https://www.cdnstyles.com/static/images/icon16/sourceId-' +
      source.sourceId +
      '.png'
    "
  />
  {{ source.name }}
  <img
    class="lsp-source-service-provider-icon"
    src="https://www.cdnstyles.com/static/images/listing-sync-pro/lsp-0.png"
    *ngIf="!!source.serviceProviders && source.serviceProviders.indexOf(1) > -1"
  />
  <img
    class="lsp-source-service-provider-icon"
    src="https://www.cdnstyles.com/static/images/listing-sync-pro/lsp-1.svg"
    *ngIf="!!source.serviceProviders && source.serviceProviders.indexOf(2) > -1"
  />
</mat-checkbox>
